import { RtError } from '@recruitee/utils';

/** Exception thrown when a ComponentPortal is attached to a DomPortalHost without an origin. */
export class DialogContentAlreadyAttachedError extends RtError {
  constructor() {
    super(
      'DialogContentAlreadyAttachedError',
      'Attempting to attach dialog content after content is already attached',
    );
  }
}
